const pendingOperations = new Set<Promise<unknown>>();

export const BackgroundService = {
	start: (task: () => Promise<unknown>) => executeWithClosePrompt(task),
};

window.addEventListener('beforeunload', (event) => {
	if (!pendingOperations.size) {
		return;
	}

	event.preventDefault();
	event.returnValue = true; // Included for legacy support, e.g. Chrome/Edge < 119
});

async function executeWithClosePrompt(task: () => Promise<unknown>) {
	const promise = task();
	pendingOperations.add(promise);

	try {
		await promise;
	} finally {
		pendingOperations.delete(promise);
	}
}
